import React, { useEffect, useState } from 'react'
import "../../assets/sass/shareStyle.scss";
// import { FaArrowLeft } from "react-icons/fa";
// import TabTitleChanger from "../TabTitleChanger";
// import usePageNavigation from '../../uesPageNavigation';

export default function PaymentInformation() {
    // const { navigateToPage, state } = usePageNavigation(); // Custom hook to navigate


    const [isOnTop, setIsOnTop] = useState(false);
    // const [isAlert, setIsAlert] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0, // Scroll to the top
            behavior: "smooth", // Smooth scrolling transition
        });
        // Check when the component mounts
        checkIfAtTop();

        // Optionally, you can listen to scroll events and check in real-time
        window.addEventListener("scroll", checkIfAtTop);

        // Cleanup listener on component unmount
        return () => window.removeEventListener("scroll", checkIfAtTop);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkIfAtTop = () => {
        if (window.scrollY === 0 || document.documentElement.scrollTop === 0) {
            setIsOnTop(true);
        } else {
            setIsOnTop(false);
        }
    };
    return (
        <div>PaymentInformation</div>
    )
}
